<template>
  <div>
    <!-- <Header /> -->

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex h-full  ">
          <!-- <div
              class="flex flex-col gap-4 lg:w-[30%] 2xl:w-[25%] overflow-y-auto"
            >
              <div class="pt-6 pb-2">
                <p class="text-primary text-center font-bold">Messages</p>
              </div>
  
              <div class="overflow-y-auto">
                <div
                  v-for="student in this.studentList.data"
                  :key="student"
                  class=""
                >
                  <p
                    v-if="student[0].display_name"
                    @click="messageInfo(student)"
                    class="py-3 px-10 text-base lg:text-sm bg-white mb-0 hover:bg-gray-200 cursor-pointer flex"
                  >
                    <span class="px-2 capitalize">{{
                      student[0].display_name
                    }}</span>
                  </p>
                </div>
              </div>
            </div> -->

          <div class="bg-[#F0F5F9] h-full w-full rounded-3xl relative">
            <div class="absolute w-full left-0 right-0">
              <div class="bg-[#FFFFFF] rounded-2xl m-4 py-2 px-3">
                <p class="text-center text-primary font-semibold">
                  Forums
                  <!-- {{ this.selectedStudent[0].display_name }} -->
                </p>
              </div>
            </div>

            <div class="h-full w-full px-3 pt-14 pb-16">
              <div class="p-4 h-full overflow-y-auto" id="chatContainer">
                <div
                  v-for="message in totalmessage"
                  :key="message"
                  class="my-4 flex flex-col gap-1"
                >
                  <p class="text-lg font-bold text-gray-600">
                    {{ message[3] }}
                  </p>
                  <span class="text-xs text-gray-600">{{ message[1] }}</span>
                  <p class="text-sm">{{ message[0] }}</p>
                </div>
              </div>
            </div>

            <div class="absolute bottom-2 w-full left-0 right-0">
              <!-- @submit.prevent="sendmsg()" -->
              <div
                class="bg-[#FFFFFF] rounded-2xl m-4 flex items-center justify-between py-2 px-3 gap-10"
              >
                <input
                  type="text"
                  class="w-[95%] border-none outline-none text-primary"
                  placeholder="Type your text here..."
                  v-model="messageVal"
                  @keyup.enter="sendmsg()"
                  name=""
                  id=""
                />
                <button
                  @click="sendmsg()"
                  class="bg-blues w-[30px] h-[30px] rounded-full flex items-center justify-center"
                >
                  <img src="@/assets/newd/arrow.png" alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- new design -->

        <!-- desktop -->
        <div class="block h-full hidden ">
          <div class="flex flex-col lg:flex-row h-full">
            <!-- left side start -->
            <div
              class="flex flex-col gap-4 h-full lg:w-[50%] 2xl:w-[25%] overflow-y-auto rounded-3xl"
              style="box-shadow: 0px 2px 30px 0px #01b0f926"
            >
              <div class="pt-6 pb-2">
                <p class="text-primary text-lg text-center font-bold">Group</p>
              </div>
              <div class="relative max-w-64 mx-auto">
                  <form @submit.prevent="searchUserValue">
                    <input
                      type="text"
                      placeholder="Search"
                      id="search"
                      v-model="search_title"
                      @input="searchUserValue"
                      class="w-full pl-4 pr-10 py-2 border  border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
                    />
                    <button type="submit" class="">
                      <div
                        class="absolute right-3 top-2.5 h-5 w-5 text-gray-400"
                      >
                        <img src="@/assets/search_icon1.svg" alt="" srcset="" />
                      </div>
                    </button>
                  </form>
                </div>

              <div>
                <div class="overflow-y-auto h-[calc(100vh-350px)]">
                  <div v-if="totalgrouplist.length > 0">
                    <div
                      v-for="group in this.totalgrouplist"
                      :key="group"
                      class=""
                    >
                      <div
                        v-if="group.title"
                        @click="messageInfo(group)"
                        class="flex items-center border-b py-3 justify-center px-10 bg-white mb-0 hover:bg-gray-200 cursor-pointer"
                      >
                        <div class="w-[11%]">
                          <p
                            class="border-1 rounded-full w-7 h-7 border-gray-300 flex items-center justify-center text-white font-bold mx-auto"
                            :style="{
                              backgroundColor: getDynamicColor(group.title),
                            }"
                          >
                            {{ group.title.charAt(0).toUpperCase() }}
                          </p>
                        </div>

                        <p
                          class="text-base lg:text-[16px] text-[#333333] w-full px-2"
                        >
                          <span class="capitalize">{{ group.title }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-else class="flex justify-center">No Group</div>
                </div>
              </div>
            </div>
            <!-- left side end -->
            <!-- Right side start -->
            <div
              v-if="ChatpopUp"
              class="bg-[#F0F5F9] h-full w-full lg:w-[75%] rounded-3xl relative"
            >
              <div class="absolute w-full left-0 right-0">
                <div
                  class="bg-[#FFFFFF] rounded-2xl m-4 py-2 px-3 flex justify-center gap-2 items-center"
                >
                  <div class="">
                    <p
                      class="border-1 rounded-full w-7 h-7 border-gray-300 flex items-center justify-center text-white font-bold mx-auto"
                      :style="{
                        backgroundColor: getDynamicColor(
                          this.selectedgroup.title
                        ),
                      }"
                    >
                      {{ this.selectedgroup.title.charAt(0).toUpperCase() }}
                    </p>
                  </div>
                  <p class="text-center text-primary font-semibold">
                    {{ this.selectedgroup.title }}
                  </p>
                </div>
              </div>

              <div class="h-full w-full px-3 pt-14 pb-16">
                <div class="p-4 h-full overflow-y-auto" id="chatContainer">
                  <div
                    v-for="message in totalmessage"
                    :key="message"
                    class="my-4 flex flex-col gap-1"
                  >
                    <!-- <p class="text-lg font-bold text-gray-600">
                      {{ message[3] }}
                    </p> -->
                    <!-- <span class="text-xs text-gray-600">{{ message[1] }}</span> -->
                    <p class="text-sm">{{ message.message }}</p>
                  </div>
                </div>
              </div>

              <div class="absolute bottom-2 w-full left-0 right-0">
                <div
                  class="bg-[#FFFFFF] rounded-2xl m-4 flex items-center justify-between py-2 px-3 gap-10"
                >
                  <input
                    type="text"
                    class="w-[95%] border-none outline-none text-primary"
                    placeholder="Type your text here..."
                    v-model="messageVal"
                    @keyup.enter="newsendmsg(this.selectedgroup)"
                    name=""
                    id=""
                  />
                  <button
                    @click="newsendmsg(this.selectedgroup)"
                    class="bg-blues w-[30px] h-[30px] rounded-full flex items-center justify-center"
                  >
                    <img src="@/assets/newd/arrow.png" alt="" />
                  </button>
                </div>
              </div>
            </div>
            <!-- Right side end -->
          </div>
        </div>

        <!-- <h1>Hello Message</h1> -->
        <!-- <table class="table-auto w-full">
              <thead>
                <tr>
                  <th class="p-4 border-b text-center border-r">
                    S NO
                  </th>
                  <th class="p-4 border-b text-center border-r">
                    Name
                  </th>
                  <th class="p-4 border-b text-center border-r">
                    Email
                  </th>
                  <th class="p-4 border-b text-center border-r">
                    Last login
                  </th>
                  <th class="p-4 border-b text-center">Mail to</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in (0, 100)" :key="i">
                  <td class="p-4 border-b text-center border-r">1</td>
                  <td class="p-4 border-b text-center border-r">
                    Malcolm Lockyer
                  </td>
                  <td class="p-4 border-b text-center border-r">
                    1961
                  </td>
                  <th class="p-4 border-b text-center border-r">
                    Last login
                  </th>
                  <th class="p-4 border-b text-center">Mail to</th>
                </tr>
              </tbody>
            </table> -->
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Student/Header.vue";
import SideBar from "@/components/Student/SideBar.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
  },
  data() {
    return {
      messageVal: null,
      totalmessage: null,
      // groupList: [
      //   { id: 1, name: "Group Name 1" },
      //   { id: 2, name: "Group Name 2" },
      //   { id: 3, name: "Group Name 3" },
      //   { id: 4, name: "Rajkumar" },
      //   { id: 5, name: "Karthik" },
      //   { id: 6, name: "Mohan" },
      //   { id: 7, name: "Vinoth" },
      //   { id: 8, name: "kumar" },
      //   { id: 9, name: "Jegan" },
      // ],

      totalgrouplist: [],

      selectedgroup: null,
      ChatpopUp: false,
      search_title:"",
    };
  },

  created() {
    this.getdetails();
    this.getgrouplist();
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
    setTimeout(() => {
      let chatContainer = document.getElementById("chatContainer");
      console.log("Height::::=", chatContainer.offsetHeight);
      if (chatContainer) {
        chatContainer.scrollTo({
          top: chatContainer.scrollHeight + 300,
          behavior: "smooth",
        });
      }
    }, 200);
  },

  methods: {
    getDynamicColor(name) {
      let hash = 0;

      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }
      const color = `#${("00000" + (hash & 0xffffff).toString(16)).slice(-6)}`;

      return color;
    },
    scrollToBottomChat() {
      setTimeout(() => {
        console.log("Height::::=", chatContainer.offsetHeight);

        chatContainer.scrollTo({
          top: chatContainer.scrollHeight + 300,
          behavior: "smooth",
        });
      }, 200);
    },

    async getdetails() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/messages/${this.userInfo.user.id}/${this.course_id}/?Key=${this.userInfo.token_key}`
        )
        .then((Response) => {
          this.totalmessage = Response.data.data.reverse();
        });

      this.scrollToBottomChat();

      //   $(".chatArea").animate(
      //     {
      //       scrollTop: $(".chatArea")[0].scrollHeight,
      //     },
      //     1000
      //   );
      // let messageDisplay = this.$refs.chatArea;
      // messageDisplay.scrollTop = messageDisplay.scrollHeight;
    },

    async sendmsg() {
      let messagesPass = {
        text: this.messageVal,
        owner: this.userInfo.user.id,
        course_code: parseInt(this.course_id),
      };

      await axios
        .post(
          `${process.env.VUE_APP_API}/talk/?Key=${this.userInfo.token_key}`,
          messagesPass
        )
        .then((Response) => {
          Response;
        });

      this.getdetails();
      // this.scrollToBottomChat();
      this.messageVal = null;

      setTimeout(() => {
        this.messageVal = null;
      }, 1000);

      //   $(".chatArea").animate(
      //     {
      //       scrollTop: $(".chatArea")[0].scrollHeight,
      //     },
      //     1000
      //   );
      // let messageDisplay = this.$refs.chatArea;
      // messageDisplay.scrollTop = messageDisplay.scrollHeight;
    },
  async  messageInfo(data) {
      if (data) {
        this.selectedgroup = data;
        this.ChatpopUp = true;
         await axios
          .get(
            `${process.env.VUE_APP_API}/group-room-get/${this.selectedgroup.id}/?Key=${this.userInfo.token_key}`
          )
          .then((Response) => {
            this.totalmessage = Response.data.data.reverse();
            console.log("this.selectedgroup.id",this.selectedgroup.id)
          });
           this.scrollToBottomChat();
      }
    },
    async getgrouplist() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/course-forum-get/?Key=${this.userInfo.token_key}&course__id=${this.course_id}`
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.totalgrouplist = response.data.data.data;
            console.log(" this.totalgrouplist", this.totalgrouplist);
          }
        });
    },
      async searchUserValue() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/course-forum-get/?search=${this.search_title}&Key=${this.userInfo.token_key}&course__id=${this.course_id}`
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.totalgrouplist = response.data.data.data;
            console.log(" this.totalgrouplist", this.totalgrouplist);
          }
        });
    },
     async newsendmsg(data) {
      let messagesPass = {
        message: this.messageVal,
        members: this.userInfo.user.id,
        forum: data.id,
      };

      await axios
        .post(
          `${process.env.VUE_APP_API}/group-room-create/?Key=${this.userInfo.token_key}`,
          messagesPass
        )
        .then((Response) => {
          Response;
        });
      this.messageInfo(this.selectedgroup);

      this.scrollToBottomChat();
     
      this.messageVal = null;
      setTimeout(() => {
        this.messageVal = null;
      }, 1000);

    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
